"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _luxon = require("luxon");

class EvaluationVersion {
  static thaw(evaluationVersionObj) {
    if (evaluationVersionObj == null) return null;
    const evaluationVersion = new EvaluationVersion();
    if (evaluationVersionObj.id != null) evaluationVersion.setId(evaluationVersionObj.id);
    if (evaluationVersionObj.semanticVersion != null) evaluationVersion.setSemanticVersion(evaluationVersionObj.semanticVersion);
    if (evaluationVersionObj.requiresAppUpdate != null) evaluationVersion.setRequiresAppUpdate(evaluationVersionObj.requiresAppUpdate == null ? null : evaluationVersionObj.requiresAppUpdate ? true : false);
    if (evaluationVersionObj.releaseDate != null) evaluationVersion.setReleaseDate(_luxon.DateTime.fromISO(evaluationVersionObj.releaseDate));
    if (evaluationVersionObj.isActive != null) evaluationVersion.setIsActive(evaluationVersionObj.isActive == null ? null : evaluationVersionObj.isActive ? true : false);
    if (evaluationVersionObj.ergoAlgoSegmentId != null) evaluationVersion.setErgoAlgoSegmentId(evaluationVersionObj.ergoAlgoSegmentId);
    if (evaluationVersionObj.evaluationQuestions != null) evaluationVersion.setEvaluationQuestions(_.EvaluationQuestion.thawList(evaluationVersionObj.evaluationQuestions));
    if (evaluationVersionObj.ergoAlgoSegment != null) evaluationVersion.setErgoAlgoSegment(_.ErgoAlgoSegment.thaw(evaluationVersionObj.ergoAlgoSegment));
    if (evaluationVersionObj.appVersions != null) evaluationVersion.setAppVersions(_.AppVersion.thawList(evaluationVersionObj.appVersions));
    if (evaluationVersionObj.evaluationRemedies != null) evaluationVersion.setEvaluationRemedies(_.EvaluationRemedy.thawList(evaluationVersionObj.evaluationRemedies));
    if (evaluationVersionObj.evaluationSections != null) evaluationVersion.setEvaluationSections(_.EvaluationSection.thawList(evaluationVersionObj.evaluationSections));
    return evaluationVersion;
  }

  static thawList(evaluationVersionObjList) {
    if (evaluationVersionObjList == null) return [];
    var evaluationVersions = [];

    for (var i = 0; i < evaluationVersionObjList.length; i++) {
      evaluationVersions.push(EvaluationVersion.thaw(evaluationVersionObjList[i]));
    }

    return evaluationVersions;
  }

  static freeze(evaluationVersion) {
    if (evaluationVersion == null) return null;
    var evaluationVersionObj = {};
    if (evaluationVersion.getId() != null) evaluationVersionObj.id = evaluationVersion.getId();
    if (evaluationVersion.getSemanticVersion() != null) evaluationVersionObj.semanticVersion = evaluationVersion.getSemanticVersion();
    if (evaluationVersion.getRequiresAppUpdate() != null) evaluationVersionObj.requiresAppUpdate = evaluationVersion.getRequiresAppUpdate() == null ? null : evaluationVersion.getRequiresAppUpdate() ? 1 : 0;
    if (evaluationVersion.getReleaseDate() != null) evaluationVersionObj.releaseDate = evaluationVersion.getReleaseDate();
    if (evaluationVersion.getIsActive() != null) evaluationVersionObj.isActive = evaluationVersion.getIsActive() == null ? null : evaluationVersion.getIsActive() ? 1 : 0;
    if (evaluationVersion.getErgoAlgoSegmentId() != null) evaluationVersionObj.ergoAlgoSegmentId = evaluationVersion.getErgoAlgoSegmentId();
    if (evaluationVersion.getEvaluationQuestions() != null) evaluationVersionObj.evaluationQuestions = _.EvaluationQuestion.freezeList(evaluationVersion.getEvaluationQuestions());
    if (evaluationVersion.getErgoAlgoSegment() != null) evaluationVersionObj.ergoAlgoSegment = _.ErgoAlgoSegment.freeze(evaluationVersion.getErgoAlgoSegment());
    if (evaluationVersion.getAppVersions() != null) evaluationVersionObj.appVersions = _.AppVersion.freezeList(evaluationVersion.getAppVersions());
    if (evaluationVersion.getEvaluationRemedies() != null) evaluationVersionObj.evaluationRemedies = _.EvaluationRemedy.freezeList(evaluationVersion.getEvaluationRemedies());
    if (evaluationVersion.getEvaluationSections() != null) evaluationVersionObj.evaluationSections = _.EvaluationSection.freezeList(evaluationVersion.getEvaluationSections());
    return evaluationVersionObj;
  }

  static freezeList(evaluationVersions) {
    if (evaluationVersions == null) return [];
    var evaluationVersionObjList = [];

    for (var i = 0; i < evaluationVersions.length; i++) {
      evaluationVersionObjList.push(EvaluationVersion.freeze(evaluationVersions[i]));
    }

    return evaluationVersionObjList;
  }

  constructor() {
    this.setId(null);
    this.setSemanticVersion(null);
    this.setRequiresAppUpdate(null);
    this.setReleaseDate(null);
    this.setIsActive(null);
    this.setErgoAlgoSegmentId(null);
    this.setEvaluationQuestions(null);
    this.setErgoAlgoSegment(null);
    this.setAppVersions(null);
    this.setEvaluationRemedies(null);
    this.setEvaluationSections(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setSemanticVersion(semanticVersion) {
    this.semanticVersion = semanticVersion;
  }

  setRequiresAppUpdate(requiresAppUpdate) {
    this.requiresAppUpdate = requiresAppUpdate;
  }

  setReleaseDate(releaseDate) {
    this.releaseDate = releaseDate;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setErgoAlgoSegmentId(ergoAlgoSegmentId) {
    this.ergoAlgoSegmentId = ergoAlgoSegmentId;
  }

  setEvaluationQuestions(evaluationQuestions) {
    this.evaluationQuestions = evaluationQuestions;
  }

  setErgoAlgoSegment(ergoAlgoSegment) {
    this.ergoAlgoSegment = ergoAlgoSegment;
  }

  setAppVersions(appVersions) {
    this.appVersions = appVersions;
  }

  setEvaluationRemedies(evaluationRemedies) {
    this.evaluationRemedies = evaluationRemedies;
  }

  setEvaluationSections(evaluationSections) {
    this.evaluationSections = evaluationSections;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getSemanticVersion() {
    return this.semanticVersion;
  }

  getRequiresAppUpdate() {
    return this.requiresAppUpdate;
  }

  getReleaseDate() {
    return this.releaseDate;
  }

  getIsActive() {
    return this.isActive;
  }

  getErgoAlgoSegmentId() {
    return this.ergoAlgoSegmentId;
  }

  getEvaluationQuestions() {
    return this.evaluationQuestions;
  }

  getErgoAlgoSegment() {
    return this.ergoAlgoSegment;
  }

  getAppVersions() {
    return this.appVersions;
  }

  getEvaluationRemedies() {
    return this.evaluationRemedies;
  }

  getEvaluationSections() {
    return this.evaluationSections;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationVersion;